import { render, staticRenderFns } from "./ProductTypes.vue?vue&type=template&id=b69663fe&scoped=true"
import script from "./ProductTypes.vue?vue&type=script&lang=js"
export * from "./ProductTypes.vue?vue&type=script&lang=js"
import style0 from "./ProductTypes.vue?vue&type=style&index=0&id=b69663fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69663fe",
  null
  
)

export default component.exports